import * as _ from 'lodash';
import RootModel from './rootModel';
import {IEdgeModel} from '@/shared/models/abstract/IEdgeModel';
import {EntityType} from "@/shared/models/entityType";

/**
 * Abstract base model for normal edges.
 */
export default class EdgeBaseModel extends RootModel implements IEdgeModel{
    _sourceId: string;
    _targetId: string;

    constructor(entityType:EntityType, sourceId:string, targetId:string, label:string="RELATED_TO") {
        super(entityType, label);
        this._sourceId = sourceId;
        this._targetId = targetId;
    }

    get sourceId(): string {
        return this._sourceId;
    }

    set sourceId(value) {
        this._sourceId = value;
        this.raisePropertyChanged('sourceId');
    }

    get targetId(): string {
        return this._targetId;
    }

    set targetId(value) {
        this._targetId = value;
        this.raisePropertyChanged('targetId');
    }

    static fromJson(json) {
        if (json.entityType !== EntityType.DefaultEdge) {
            throw new Error('Wrong deserialization data.');
        }
        let m = new EdgeBaseModel(null,null,null);
        m = _.assign(m, json);
        return m;
    }

    toJson() {
        const m:any = super.toJson();
        m.sourceId = this._sourceId;
        m.targetId = this._targetId;
        return m;
    }
}
